import React from "react";

import { cn } from "@/utils/cn";

import { Avatar } from "../ui";

import type { Group } from "@/schemas";

interface GroupAvatarProps {
  group: Group;
  size: number;
  withRing?: boolean;
}

const GroupAvatar = (props: GroupAvatarProps) => {
  const { group, size, withRing = false } = props;

  return (
    <Avatar
      className={cn("relative shrink-0 rounded-full", {
        "shadow-[0_0_0_4px_var(--color-white)] dark:shadow-[0_0_0_4px_var(--color-gray-900)]":
          withRing,
      })}
      src={group.avatar_static}
      size={size}
    />
  );
};

export default GroupAvatar;
